function checkUserParams(params) {
  let result = true
  if (!params.name1 || !params.name2) {
    this.errors['name'] = true
    this.errors['name_required'] = true
    result = false
  }

  const requiredParams = [
    'email',
    'email_confirm',
    'password',
    'password_confirm'
  ]

  const confirmableParams = [
    'email',
    'email2',
    'password'
  ]

  requiredParams.forEach(prop => {
    if (!params[prop]) {
      this.errors[prop] = true
      this.errors[`${prop}_required`] = true
      result = false
    }
  })

  confirmableParams.forEach(prop => {
    const val1 = params[prop]
    const val2 = params[`${prop}_confirm`]
    if (val1 !== val2) {
      this.errors[`${prop}_confirm`] = true
      this.errors[`${prop}_confirm_unmatch`] = true
      result = false
    }
  })

  if (params.password) {
    const errObj = checkValidPassword(params.password)
    if (Object.keys(errObj).length > 0) {
      Object.keys(errObj).forEach(k => {
        this.errors[k] = errObj[k]
      })
      result = false
    }
  }

  return result
}

function checkPassword(params) {
  let result = true

  const requiredParams = [
    'password',
    'password_confirm',
  ]
  const confirmableParams = [
    'password',
  ]
  requiredParams.forEach(prop => {
    if (!params[prop]) {
      this.errors[prop] = true
      this.errors[`${prop}_required`] = true
      result = false
    }
  })
  confirmableParams.forEach(prop => {
    const val1 = params[prop]
    const val2 = params[`${prop}_confirm`]
    if (val1 !== val2) {
      this.errors[`${prop}_confirm`] = true
      this.errors[`${prop}_confirm_unmatch`] = true
      result = false
    }
  })

  let errObj = checkValidPassword(params.password)
  if (Object.keys(errObj).length > 0) {
    Object.keys(errObj).forEach(k => {
      this.errors[k] = errObj[k]
    })
    result = false
  }

  return result
}

function checkValidPassword(pw) {
  const ret = {}
  const allowedReg = /^(?=.*?[a-zA-Z])(?=.*?\d)[a-zA-Z\d]{8}$/

  if (!pw.match(allowedReg)) {
    ret.password_invalid = true
  }

  return ret
}

export default {
  methods: {
    checkUserParams,
    checkPassword,
    checkValidPassword,
  }
}
